module.exports = __webpack_public_path__ + "static/media/test2.a8ea0d9b.jpg";